import httpService from "../httpService";

export default {
  findAll() {
    return httpService.get("/hcCfgAirport");
  },
}



// WEBPACK FOOTER //
// ./src/services/maybay/hcCfgAirportService.js